import React from 'react'
import { FocusSensor } from 'libreact/lib/FocusSensor'
import styled from 'styled-components'

const borderBottom = (props) => {
  if (props.error) return props.theme.borders.red
  if (props.isFocused) return props.theme.borders.green3

  return props.theme.borders.grey6
}

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10px 5px;
  border-bottom: ${props => borderBottom(props)};

  &:hover {
    border-bottom: ${props => props.isFocused ? props.theme.borders.green3 : props.theme.borders.grey5};
  }
`

const color = ({
  isDisabled,
  isDefault,
  theme: {
    colors: {
      grey,
      grey10,
      grey9,
    },
  },
}) => {
  if (isDisabled) return grey10
  if (isDefault) return grey9

  return grey
}

const Input = styled.input`
  width: 100%;
  text-align: ${props => props.textAlign || 'center'};
  font-size: 14px;
  font-weight: ${props => props.readOnly ? 700 : 400};
  color: ${props => color(props)};
`

export default ({
  disabled,
  onClick,
  bold,
  colorful,
  readOnly,
  error,
  ...props,
}) => (
  <FocusSensor>
    {({ isFocused }) => (
      <Container
        onClick={onClick}
        isFocused={isFocused}
        readOnly={readOnly}
        error={error}
      >
        <Input
          type='text'
          isDisabled={disabled}
          readOnly={readOnly}
          {...props}
        />
      </Container>
    )}
  </FocusSensor>
)
